import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { getFiltrarCupones, getLocalesFiltrarPorNombre, getNotificaciones } from "../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Delete, Edit } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NotificacionesHeader from "./components/NotificacionesHeader";
import NotificacionesFiltrosComponents from "./components/NotificacionesFiltrosComponents";
import NotificacionesTableComponent from "./components/NotificacionesTableComponent";



function NotificacionesPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [loading, setLoading] = useState(false);

    const [searchFilter, setSearchFilter] = useState("");
    const [dataNotificaciones, setDataNotificaciones] = useState([]);
    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);




    const [locales, setLocales] = useState([]);
    const [localesSearch, setLocalesSearch] = useState('');
    const [localesSelected, setLocalesSelected] = useState(null);
    const [loadingCargarLocales, setLoadingCargarLocales] = useState(false);

    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [usuarioNameSearch, setUsuarioNameSearch] = useState('');
    const [nameSelected, setNameSelected] = useState(null);
    const [loadingCargarName, setLoadingCargarName] = useState(false);


    const [dataCupones, setDataCupones] = useState([]);

    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaInicioBackend, setFechaInicioBackend] = useState('');
    const [fechaFin, setFechaFin] = useState(null);
    const [fechaFinBackend, setFechaFinBackend] = useState('');




    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();




    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (searchFilter.length > 2) {

                handleApiFiltrarNotificaciones(1);
            } else {
                handleApiFiltrarNotificaciones(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, searchFilter, perPage]);





    // Funcion para filtrar compras por los parametros del endpoint.
    const handleApiFiltrarNotificaciones = (page = 1) => {
        const body = {
            page: page,
            per_page: perPage,
            titulo: searchFilter,
        };

        setLoadingCargar(true);

        getNotificaciones(stateToken?.access_token, body)
            .then((response) => {
                console.log("response==>getNotificaciones", response?.data);

                setDataNotificaciones(response?.data?.data || []);
                setLoading(true);


                setMetaPaginacion({
                    current_page: response?.data?.current_page,
                    per_page: response?.data?.per_page,
                    total: response?.data?.total,
                    last_page: response?.data?.last_page
                });
                setLoadingCargar(false);
            })
            .catch((error) => {
                console.log("error==>getNotificaciones", error);
                setDataNotificaciones([]);
                setMetaPaginacion({
                    current_page: 1,
                    per_page: perPage,
                    total: 0,
                    last_page: 1,
                });
                setLoading(true);
                setLoadingCargar(false);
            });
    };



    //=================================================================================================funcion para ir a la pantalla de agregar
    const handleAddNotificacion = () => {
        history('/app/admin/notificacion-add');
    };


    const handleSearchChange = (value) => {
        setSearchFilter(value);
    };



    const handleEditarItem = (item) => {
        // console.log("usuario a editar==>", item);
        // history(`/app/admin/paseo-plus/vales/editar/${item?.id}`);

    };

    //=============================================funcion para ver sin editar el banner
    const handleVerDetalle = (item) => {
        // console.log('Edit', item?.id);
        // history(`/app/admin/paseo-plus/vales/detalle/${item?.id}?mode=view`);
    };


    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <NotificacionesHeader
                            title="Notificaciones"
                            subtitle="Administra y supervisa las notificaciones de la plataforma."
                            handleAdd={handleAddNotificacion}
                        />




                        <div>
                            <NotificacionesFiltrosComponents
                                searchValue={searchFilter}
                                onSearchChange={handleSearchChange}


                            // statusFilter={statusFilter}
                            // onStatusChange={handleStatusChange}
                            // statusOptions={statusOptions}
                            />


                            <NotificacionesTableComponent
                                data={dataNotificaciones}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarNotificaciones}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditarItem}
                                handleVerDetalle={handleVerDetalle}
                            />
                        </div>




                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}


                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default NotificacionesPage;